<!-- @author Priya Murpani -->

<div
class="main-container"
[class.center-error]="applyForPermitData.errorMsg"
[class.no-scroll]="showOverlay"
[class.loading]="isLoading"

  >
    <div class="application-overlay" *ngIf="showOverlay">
      <div class="loader-overlay" *ngIf="isLoading">
        <div class="loader"></div>
      </div>

</div>

<!-- Main header -->
<div
  *ngIf="applyForPermitData.errorMsg"
  class="error-container"
>
  <wm-common-icon
    class="error-icon"
    [data]="{ iconName: 'error' }"
  ></wm-common-icon>
  <wm-common-text
    [data]="{ text: applyForPermitData.errorMsg }"
    class="error-header"
  ></wm-common-text>
</div>
<!-- Header container -->
<div
  class="header-container padding-container"
  *ngIf="!applyForPermitData.errorMsg"
>
  @if (!applyForPermitData.loading) {
  <wm-common-text [data]="{ text: applyForPermitData.headerData, }">
  </wm-common-text>
  } @else {
  <div class="skeleton skeleton-text"></div>
  } @if (!applyForPermitData.loading) {

  <ng-container
    *ngIf="applyForPermitData.departmentData?.[selectedDepartmentIndexDesktop]?.header; else emptySpace"
  >
    <wm-applicant-home-drawer-heading
      [data]="{
        header: 'Welcome to GeoPermits',
        subHeader:
        'To apply for a new permit, choose the town department from the tabs below and then click on the appropriate application link.'
      }"
    ></wm-applicant-home-drawer-heading>
  </ng-container>

  <ng-template #emptySpace>
    <div class="sub-header-space"></div>
  </ng-template>

  } @else {

  <div class="skeleton skeleton-sub-text"></div>
  }
</div>
<!-- laptop view -->
<div class="department-content" *ngIf="!applyForPermitData.errorMsg">
  <!-- Departments in a row -->

  <div
    class="department-data"
    [ngStyle]="{
      'border-bottom': !applyForPermitData.loading
        ? '1px solid rgba(217, 217, 217, 1)'
        : 'none'
    }"
  >
    @if(applyForPermitData.loading){
    <div class="department-content-skeleton">
      <div class="skeleton-item" *ngFor="let s of skeletonArray"></div>
    </div>
    }@else{

    <!-- Left Arrow -->
    <img
      *ngIf="showBackward"
      [src]="moveBackwardIcon"
      alt="move-backward"
      class="move-icon"
      (click)="scrollDepartments('left')"
    />

    <!-- Scroll container -->

    <div
      class="department-container"
      #deptContainer
      (scroll)="onDepartmentScroll()"
    >
      <div
        class="department"
        *ngFor="
          let dept of applyForPermitData.departmentData;
          let i = index
        "
        [class.active]="selectedDepartmentIndexDesktop === i"
        (click)="selectedDepartmentIndexDesktop = i; onDepartmentSelect(i)"
        tabindex="0"
        (keydown.enter)="onDepartmentSelect(i)"
        (keydown.space)="onDepartmentSelect(i)"
      >
        @if(dept.departmentSvg === '') {
        <wm-common-icon
          class="department-icon"
          [data]="{ iconName: formDescriptionIcon }"
        ></wm-common-icon>
        }@else {
        <wm-common-icon
          class="department-icon"
          [data]="{ iconName: dept.departmentSvg }"
        ></wm-common-icon
        >}
        <wm-common-text
          class="dept-label"
          [matTooltip]="
            dept.departmentName.length > 17
              ? (dept.departmentName | titlecase)
              : ''
          "
          matTooltipClass="custom-tooltip-style"
          matTooltipPosition="above"
          [data]="{
            text:
              dept.departmentName.length > 17
                ? (dept.departmentName | slice: 0:17) + '...'
                : dept.departmentName,
            textTransform: 'uppercase'
          }"
        ></wm-common-text>
      </div>
    </div>
    <!-- Right Arrow -->
    <img
      *ngIf="showForward"
      [src]="moveForwardIcon"
      alt="move-forward"
      class="move-icon"
      (click)="scrollDepartments('right')"
    />

    }
  </div>

  <!-- Dynamic department content -->

  @if(applyForPermitData.loading){

  <!-- Show 2–3 skeleton items -->
  <div class="skeleton department-skeleton-content"></div>
  <div class="skeleton department-skeleton-content2"></div>
  <div class="skeleton department-skeleton-content"></div>

  }@else {
  <div
    class="dept-content padding-container"
    *ngIf="applyForPermitData?.departmentData?.[selectedDepartmentIndexDesktop] as department"
  >
    <div *ngFor="let content of department.departmentContent">
      <wm-common-text [data]="{ text: content }"></wm-common-text>
    </div>
  </div>
  }
  <!--Permit  Applications -->
  <!-- Department Header -->

  <div
    class="permit-header-container"
  >
    @if(applyForPermitData.loadingPermitLinks){
    <div class="skeleton dept-skeleton-header"></div>
    } @else{<wm-common-text
      *ngIf="!applyForPermitData.errorMsgOfPermitLinks"
      class="permit-header"
      [data]="{text:applyForPermitData?.departmentData?.[selectedDepartmentIndexDesktop]?.departmentHeader}"
    >
    </wm-common-text>
    }
  </div>

  <!-- Permit Links -->
  <div
    class="permit-links permit-link-padding-container"
    [class.center-errorOfPemit]="applyForPermitData?.errorMsgOfPermitLinks"
  >
    <!-- Skeleton first (always safe to render) -->
    <ng-container
      *ngIf="applyForPermitData.loadingPermitLinks; else showWorkflows"
    >
      <div class="permit-link" *ngFor="let _ of skeletonArray">
        <div class="permit-text-skeleton"></div>
      </div>
    </ng-container>

    <!-- Actual workflows -->
    <ng-template #showWorkflows>
      <ng-container
        *ngIf="applyForPermitData?.departmentData?.[selectedDepartmentIndexDesktop] as department"
      >
        <div
          class="permit-link"
          *ngFor="
            let workflow of department.departmentWorkflows;
            let idx = index
          "
          tabindex="0"
          (keydown.enter)="startPermitWorkflow(idx)"
          (keydown.space)="startPermitWorkflow(idx)"
          (click)="startPermitWorkflow(idx)"
        >
          <wm-common-text
            [data]="{ text: workflow.applicationPermitName }"
          ></wm-common-text>
        </div>

        <div
          *ngIf="
            !applyForPermitData.loading &&
            applyForPermitData.errorMsgOfPermitLinks"
class="error-container">
          <wm-common-icon
            class="error-icon"
            [data]="{ iconName: 'error' }"
          ></wm-common-icon>
          <wm-common-text
            [data]="{ text: applyForPermitData.errorMsgOfPermitLinks }"
            class="error-header"
          ></wm-common-text>
        </div>
      </ng-container>
    </ng-template>
  </div>

  <!-- Skeleton list -->
  <ng-template #skeletonList>
    <div class="permit-link" *ngFor="let _ of skeletonArray">
      <div class="permit-text-skeleton"></div>
    </div>
  </ng-template>
</div>
<!-- mobile view -->
<mat-accordion
  *ngIf="!applyForPermitData.errorMsg"
  class="department-accordion"
>
  @if(applyForPermitData.loading){
  <div *ngFor="let _ of skeletonBlocks" class="dept-text-skeleton"></div>
  } @else{

  <mat-expansion-panel
    *ngFor="let dept of applyForPermitData.departmentData; let i = index"
    class="department-panel"
    (opened)="onDepartmentOpen(i, dept)"
    [expanded]="isMobileDevice && selectedDepartmentIndexMobile === i"
  >
    <mat-expansion-panel-header>
      <div
        class="department-mobile"
        [class.active]="selectedDepartmentIndexMobile === i"
      >
        @if(dept.departmentSvg === '') {
        <wm-common-icon
          class="department-icon"
          [data]="{ iconName: formDescriptionIcon }"
        ></wm-common-icon>
        }@else {
        <wm-common-icon
          class="department-icon"
          [data]="{ iconName: dept.departmentSvg }"
        ></wm-common-icon
        >}

        <wm-common-text
          [data]="{ text: dept.departmentName, textTransform: 'uppercase' }"
        ></wm-common-text>
      </div>
    </mat-expansion-panel-header>
    <div class="panel-content">
      <div class="department-header-content">
        <wm-common-text
          *ngFor="let content of dept.departmentContent"
          [data]="{ text: content }"
        >
        </wm-common-text>
      </div>
      <wm-common-text
        class="dept-header"
        [data]="{ text: dept.departmentHeader }"
      >
      </wm-common-text>
      <!-- Permit Links -->
      <div
        class="permit-links"
        [class.center-errorOfPemit]="dept.errorMsgOfPermitLinks"
      >
        <!-- Skeleton for this panel -->
        <ng-container *ngIf="dept.loadingPermitLinks">
          <div
            *ngFor="let _ of skeletonArray"
            class="permit-text-skeleton"
          ></div>
        </ng-container>

        <!-- Workflows list -->
        <div
          class="permit-link"
          *ngFor="let workflow of dept.departmentWorkflows; let idx = index"
          (click)="startPermitWorkflow(idx)
          "
        >
          <wm-common-text
            class="permit"
            [data]="{ text: workflow.applicationPermitName }"
          ></wm-common-text>
        </div>

        <!-- Error message only for this dept -->
        <div *ngIf="dept.errorMsgOfPermitLinks" class="error-container">
          <wm-common-icon
            class="error-icon"
            [data]="{ iconName: 'error' }"
          ></wm-common-icon>

          <wm-common-text
            class="error-header"
            [data]="{ text: dept.errorMsgOfPermitLinks }"
          ></wm-common-text>
        </div>
      </div>
    </div>
  </mat-expansion-panel>
  }
</mat-accordion>
</div>
